import * as React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { IconButton } from '@material-ui/core';
import { GridRowData } from '@material-ui/data-grid';
import { Visibility } from '@material-ui/icons';
import { Link } from '@components/link';

export const IconButtonSession = ({ params }: GridRowData) => {
  const { url } = useRouteMatch();

  return (
    <>
      <IconButton
        color='primary'
        size='small'
        disabled={!params.gameSessionId}
        component={Link}
        avoidPrefix
        to={`${url.replace(/(\/\d+)*\/?$/i, '')}/${params.sessionId}/${params.gameSessionId}`}
      >
        <Visibility />
      </IconButton>
    </>
  );
};
